import {parse} from "lossless-json"
import api from "./base-api"

const cmProgressApi = api.injectEndpoints({
    endpoints: (build) => ({
        getCmProgress: build.query({
            query: (userId) => ({
                url: `v3/cm/progress/${userId}`,
                responseHandler: (response) => response.text()
            }),
            transformResponse: (text) => ({
                data: JSON.parse(text),
                raw: parse(text)
            }),
            providesTags: (_r, _e, userId) => [{type: "CmProgress", id: userId}]
        }),
        putCmProgress: build.mutation({
            query: ({userId, body}) => ({
                url: `v3/cm/progress/${userId}`,
                method: "PUT",
                headers: {"Content-Type": "application/json"},
                body
            }),
            invalidatesTags: (_r, _e, {userId}) => [{type: "CmProgress", id: userId}]
        })
    }),
    overrideExisting: false
})

export const {
    useGetCmProgressQuery,
    usePutCmProgressMutation
} = cmProgressApi
